
import { JobService } from "@/services/job-service";
import { SaleService } from "@/services/sale-service";
import Vue from "vue";
import { BookYearService } from "../../services/book-year-service";
import AppAccountingIntraConsignmentModal from "@/components/bookkeeping/AccountinginitIntraConsignmentModal.vue";
import AppCraateVatDeclarationModal from "@/components/bookkeeping/AccountingVatDeclarationModal.vue";
import { AuthService } from "@/services/auth-service";
import { MODULE } from "@/config/modules";
import { PurchaseService } from "@/services/purchase-service";
import { AllContactsService, BankService } from "@/services";
import { BookYear } from "@/models/book-year";
import { printLocalDateTime } from "@/utils/pretty-print";
import { TranslateResult } from "vue-i18n";
import AppMultiSelectBookYearModal from "@/components/bookyear/MultiSelectBookYearModal.vue";

export default Vue.extend({
	data() {
		return {
			JobService,
			hasNewerBookYear: (BookYearService.getNewestBookYear().Year > BookYearService.selectedBookYear),
			intraConsignmentModal: false,
			vatDeclarationModal: false,
			copyBankSaldosRunning: false,
			recomputeContactStatsModal: false
		};
	},
	computed: {
		afpuntenRunning():boolean {
			return this.JobService.getJobs().findIndex(a => a.Name == "afpunten") != -1;
		},
		saldosOverboekenRunning():boolean {
			return this.JobService.getJobs().findIndex(a => a.Name == "saldos-overboeken") != -1;
		},
		purchaseAfpuntenRunning():boolean {
			return this.JobService.getJobs().findIndex(a => a.Name == "purchases-afpunten") != -1;
		},
		purchaseSaldosOverboekenRunning():boolean {
			return this.JobService.getJobs().findIndex(a => a.Name == "purchase-saldos-overboeken") != -1;
		},
		recomputeContactStatsRunning():boolean {
			return this.JobService.getJobs().findIndex(a => a.Name == "recompute-contact-stats") != -1;
		},

		fillLedgersRunning():boolean {
			return this.JobService.getJobs().findIndex(a => a.Name == "fill-ledgers") != -1;
		},
		canDoIntraConsignment():boolean {
			return AuthService.hasModule(MODULE.BTW_AANGIFTE_EN_LISTING);
		},
		currentBookYearObj():BookYear{
			return BookYearService.selectedBookYearObj;
		},
		currentBookYear():number {
			return BookYearService.selectedBookYear;
		},
		newerBookYear():number {
			return this.currentBookYear +1;
		}
	},
	methods: {
		async afpunten() {
			await SaleService.afpunten();
		},
		async saldosOverboeken() {
			await SaleService.saldosOverboeken();
		},
		async purchaseAfpunten() {
			await PurchaseService.afpunten();
		},
		async purchaseSaldosOverboeken() {
			await PurchaseService.saldosOverboeken();
		},
		async fillLedgers(){
			await SaleService.fillLedgers();
		},
		openIntraConsignment(){
			this.intraConsignmentModal = true;
		},
		openCreateVatDeclarationModal(){
			this.vatDeclarationModal = true;
		},
		async copyBankSaldos(){
			if (this.copyBankSaldosRunning) return;
			this.copyBankSaldosRunning = true;
			try{
				await BankService.copyBankSaldosToNewerBookYear();
				this.$wf.notify(this.$ct("bank-saldos-copied"), "success", 3000, "check");
			}catch(err){

			}finally{
				this.copyBankSaldosRunning = false;
			}
		},
		getLastExecutedText(date:Date | null):string | TranslateResult{
			if (!date) return "";
			return this.$ct("last-executed-on", {date: printLocalDateTime(date)}) ;
		},
		recomputeContactStatsClicked(){
			this.recomputeContactStatsModal = true;
		},
		async recomputeContactStats(bookyears:number[]){
			await AllContactsService.recomputeContactStats(bookyears);
		}
	},
	components: {
		AppAccountingIntraConsignmentModal,
		AppCraateVatDeclarationModal,
		AppMultiSelectBookYearModal
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
